import { deviceType } from "@tm/isomorphic-utils";
import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const PlanCardsOuter = styled.section`
  background: ${theme.whiteText};
  border-radius: 16px;
  box-shadow: 0px 10px 30px rgba(175, 175, 175, 0.1);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;

  @media ${deviceType.mobile} {
    padding: 16px;
    border-radius: 12px;
  }
`;

export const PlanCardsInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${deviceType.mobile} {
    gap: 16px;
  }
`;

export const HeaderAndCardsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  @media ${deviceType.mobile} {
    gap: 20px;
  }
`;

export const CardsScrollContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CardsGrid = styled.div`
  display: flex;
  gap: 24px;
  align-items: stretch;
  width: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  padding-top: 12px;
  margin-top: -12px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${deviceType.mobile} {
    flex-direction: column;
    flex-wrap: wrap;
    overflow-x: visible;
    scroll-snap-type: none;
    gap: 20px;
  }
`;

export const ScrollArrow = styled.button<{ $direction: "left" | "right" }>`
  position: absolute;
  top: 50%;
  ${(p) => (p.$direction === "left" ? "left: -16px" : "right: -16px")};
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid ${theme.lightSilver};
  background: ${theme.whiteText};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;
  padding: 0;

  &:hover {
    background: ${theme.lightGreyBG};
  }

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
  }

  @media ${deviceType.mobile} {
    display: none;
  }
`;
